/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'contractMsg': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M879.7 957.5H144.4c-52.5 0-95.2-37.5-95.2-83.6V762.5c0-46.1 42.7-83.6 95.2-83.6h252.5c6.3-19 9.6-39.9 9.6-61.3 0-52.6-20.5-101.7-52.1-124.9-1.1-.8-2.2-1.7-3.2-2.7l-9.8-9.6C280 435.7 244.9 370 244.9 300c0-129.3 119.8-234.5 267.2-234.5 147.3 0 267.2 105.2 267.2 234.5 0 69.8-35 135.4-96 180.1l-10.1 9.9c-1 1-2.1 1.9-3.2 2.7-31.7 23.3-52.1 72.3-52.1 124.9 0 21.5 3.3 42.3 9.6 61.3h252.4c52.5 0 95.2 37.5 95.2 83.6V874c-.2 46-42.9 83.5-95.4 83.5zM627.3 451.3l10.3-10c1.1-1 2.3-2 3.5-2.9 47.5-34.1 74.7-84.6 74.7-138.4 0-98.6-91.4-178.8-203.7-178.8-112.3 0-203.7 80.2-203.7 178.8 0 54 27.4 104.5 75.1 138.7 1.2.9 2.4 1.9 3.5 2.9l10 9.7c45.1 34.3 73 97.7 73 166.3 0 21-2.6 41.7-7.6 61.3h99.4c-5-19.6-7.6-40.3-7.6-61.3 0-68.6 27.9-132 73.1-166.3zm284.1 311.2c0-15.4-14.2-27.9-31.7-27.9H144.4c-17.5 0-31.7 12.5-31.7 27.9V874c0 15.4 14.2 27.9 31.7 27.9h735.3c17.5 0 31.7-12.5 31.7-27.9V762.5z" _fill="#0C0C0C"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/contractMsg.js